import {
  LayoutGrid,
  Filter,
  DollarSign,
  Users,
  Clock,
  TrendingUp,
  MapPin,
  BarChart3,
  UserCog,
  Ticket,
  Wallet,
  LucideIcon,
} from "lucide-react";
import { PartnerCapabilities } from "./capabilities";

export type SectionKey =
  | "overview"
  | "funnel"
  | "revenue"
  | "members"
  | "expiring"
  | "opportunities"
  | "locations"
  | "reports"
  | "payments"
  | "staff"
  | "classDrops";

export interface SectionDef {
  key: SectionKey;
  label: string;
  icon: LucideIcon;
  visible: (c: PartnerCapabilities) => boolean;
  multiLocationOnly?: boolean;
}

export const SECTIONS: SectionDef[] = [
  { key: "overview", label: "Overview", icon: LayoutGrid, visible: () => true },
  { key: "funnel", label: "Funnel", icon: Filter, visible: () => true },
  { key: "revenue", label: "Revenue", icon: DollarSign, visible: (c) => c.canViewRevenue },
  { key: "members", label: "Members", icon: Users, visible: () => true },
  { key: "expiring", label: "Expiring Soon", icon: Clock, visible: () => true },
  { key: "opportunities", label: "Upgrade Opportunities", icon: TrendingUp, visible: () => true },
  { key: "locations", label: "Locations", icon: MapPin, visible: () => true, multiLocationOnly: true },
  { key: "reports", label: "Reports", icon: BarChart3, visible: (c) => c.canViewRevenue },
  { key: "payments", label: "Payments", icon: Wallet, visible: (c) => c.canViewRevenue },
  { key: "classDrops", label: "Class Drops", icon: Ticket, visible: (c) => c.canViewRevenue },
  { key: "staff", label: "Staff", icon: UserCog, visible: (c) => c.canManageStaff },
];

export const visibleSections = (
  c: PartnerCapabilities,
  multiLocation: boolean
): SectionDef[] =>
  SECTIONS.filter((s) => s.visible(c)).filter(
    (s) => !s.multiLocationOnly || multiLocation
  );
